import type { Directive } from 'vue'

import type { AnalyticsParams } from '~/composables/useAnalytics'

type TrackedElement = HTMLElement & {
  __trackClick?: AnalyticsParams
  __trackClickHandler?: () => void
}

const trackClick: Directive<TrackedElement, AnalyticsParams> = {
  mounted(el, { value }) {
    el.__trackClick = value
    el.__trackClickHandler = () => trackEvent('cta_click', el.__trackClick)
    el.addEventListener('click', el.__trackClickHandler)
  },
  updated(el, { value }) {
    el.__trackClick = value
  },
  unmounted(el) {
    if (el.__trackClickHandler) {
      el.removeEventListener('click', el.__trackClickHandler)
    }
  },
  getSSRProps: () => ({}),
}

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive('track-click', trackClick)
})
